import $ from 'jquery';
export default function (string) {
  if (typeof string === 'string') {
    return $($.parseHTML(`<div>${string}</div>`)[0]);
  } else {
    throw new Error("Trying to create jQuery object from something that isn't a string");
  }
}